// extracted by mini-css-extract-plugin
export var container = "_g5-1";
export var cornerButtonContainer = "_g5-6";
export var disabled = "_g5-2";
export var dragActive = "_g5-3";
export var fileContainer = "_g5-5";
export var hiddenInput = "_g5-4";
export var widthContainer = "_g5-0";